/**
 * Standalone Telegram glyph. Lives in its own file so consumers that
 * only need the icon (header pills, sidebar items) don't pull in the
 * entire TelegramBotModal — which carries framer-motion + Privy hooks
 * and is only mounted on click.
 */
export function TelegramIcon({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden>
      <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.894 8.221l-1.97 9.28c-.145.658-.537.818-1.084.508l-3-2.21-1.446 1.394c-.14.14-.257.259-.522.259l.186-2.644 4.808-4.346c.209-.185-.045-.288-.324-.103l-5.944 3.744-2.56-.8c-.556-.174-.567-.556.116-.823l10.007-3.854c.464-.174.868.104.713.789z" />
    </svg>
  );
}
